import { LoginResponse } from '@/auth/interface/auth.interface';
import { UploadingDocumentState } from '@/interfaces/documents';
import { Details } from '@/interfaces/requirement/index';
import { EditingTaskForm, EditingTaskToSend } from '@/interfaces/task-user/task-user';
import { RequirementService } from '@/services/requirement/requirement.service';
import { TaskDetailAndTotalTasksService } from '@/services/taskDetailAndTotalTasks/task-detail-and-total-tasks.service';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';
import { modalShow } from '@/store/modal/actions';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { normalize } from '@/utils/normalizeString';
import { deofuscate, ofuscate } from '@/utils/obfuscation';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AssetsFilesService } from '@/services/assetsFilesService/assets-files.service';

@Component({
  selector: 'app-background-update',
  templateUrl: './background-update.component.html',
  styleUrls: ['./background-update.component.css'],
})
export class BackgroundUpdateComponent implements OnInit {

  driverIsEmployee: boolean = false;

  constructor(
    private store: Store<StoreState>,
    private taskService: TaskDetailAndTotalTasksService,
    private requirementService: RequirementService,
    private route: ActivatedRoute,
    private router: Router,
    private assetsFilesService: AssetsFilesService,
  ) {
    getCurrentUserData(this.store).subscribe({
      next: (userData) => {
        this.userData = userData;
        this.driverIsEmployee = normalize(userData.entity) === normalize('Employee');
      },
    });
  }

  get assetName(): string {
    if (this.detailData && this.detailData.assetId) {
      // eslint-disable-next-line eqeqeq
      return this.detailData.assetId == 1 ? 'Escondida' : 'Spence';
    }
    return '';
  }

  ngOnInit() {
    this.route.params.subscribe(({ ofuscatedData }) => {
      const params = deofuscate(ofuscatedData);
      this.id = params.id;
      this.requirementService.getDetails(params.id).subscribe({
        next: (detailData: Details) => {
          this.detailData = detailData;
        },
      });
    });
  }
  /// // CONFIRM MODAL  ///////////
  modalState: boolean = false;
  /// ///////////details  equipment ///////////

  id: number = 0;
  detailData?: Details;

  // Documents

  updatingDocument: Partial<EditingTaskForm>[] = [];

  userData: Partial<LoginResponse> = {};

  formOk: boolean = false;

  showModalConfirmUpdateDocuments() {
    this.store.dispatch(modalShow({
      title: '¿Estás seguro de guardar los cambios?',
      text: `
      Si ya has revisado la información registrada y está correcta, continúa en enviar los cambios.
      De lo contrario, ingresa Volver para revisar la información.
    `,
      acceptButtonText: 'Enviar los cambios',
      actionOnAccept: () => {

        if (this.userData.mdmid) {
          const updatedDocs = this.updatingDocument.filter((document) => document?.isEditing);

          const outData = updatedDocs.map((document) => {
            const { detailData } = this;
            if (detailData) {
              const detail = (detailData.documents || []).find((detailDoc) => detailDoc.id === document.documentId);
              if (detail) {
                return {
                  id: document.documentId,
                  documentRequiredTypeId: detail.documentRequiredTypeId,
                  fileName: document.fileName,
                  path: document.fileUrl,
                  createdAt: document.dateEmit,
                  dateFrom: document.dateFrom,
                  dateTo: document.dateUntil,
                };
              }
            }
            return {};
          });

          this.store.dispatch(loaderAnimationShow());
          this.taskService.taskUpdate(this.id, <unknown>outData as EditingTaskToSend[])
            .subscribe({
              next: (res: any) => {
                const ofuscateData = ofuscate({ id: this.id });
                this.router.navigateByUrl(`/tasks/success-task-update/${ofuscateData}`);
              },
              error: (err: any) => {
                this.store.dispatch(loaderAnimationHide());
                this.router.navigateByUrl('/tasks/failure-task-update', {
                });
              },
              complete: () => {
                this.store.dispatch(loaderAnimationHide());
              },
            });
        }
      },
    }));
  }

  messageInformation: boolean = false
  onShowInformationIcon() {
    this.messageInformation = true;
  }

  // /////////////// validacion de  actualizacion  /////////////

  // Documents

  showDocumentUpdateForm(index: number, id: number, documentRequiredTypeId: number) {
    this.updatingDocument[index] = {
      requestId: this.id,
      documentRequiredTypeId,
      documentId: id,
      isEditing: false, // default false
    };
    const currentValue = this.updatingDocument[index].isEditing;
    this.updatingDocument[index].isEditing = !currentValue;
  }

  onFileSelected(index: number, fileLoadingStatus: UploadingDocumentState) {
    if (fileLoadingStatus.status === 'error') {
      this.updatingDocument[index] = {
        ...this.updatingDocument[index],
        errorKey: 'fileUrl',
        errorText: fileLoadingStatus.description,
      };
    }
    else if (fileLoadingStatus.status === 'uploaded') {
      const { detailData } = this;
      if (detailData) {
        if (detailData.documents) {
          this.updatingDocument[index] = {
            dateEmit: detailData.documents[index].dateEmit,
            dateFrom: detailData.documents[index].dateFrom,
            dateUntil: detailData.documents[index].dateUntil,
            ...this.updatingDocument[index],
            fileUrl: fileLoadingStatus.fileUrl,
            fileName: fileLoadingStatus.fileName,
            errorKey: '',
            errorText: '',
          };
        }
      }
      this.verifyEditForm();
    }
    else {
      this.updatingDocument[index] = {
        ...this.updatingDocument[index],
        errorKey: '',
        errorText: '',
      };
    }

  }

  verifyEditForm(): boolean {
    let documentWasModified = false;
    const allOk = this.updatingDocument.every((documentForm, index) => {
      if (documentForm?.isEditing) {
        documentWasModified = true;
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        if ('dateEmit' in documentForm && !('dateFrom' in documentForm)) {
          const dateEmit = <Date | ''>documentForm.dateEmit;
          if (dateEmit > currentDate) {
            this.updatingDocument[index].errorKey = 'dateEmit';
            this.updatingDocument[index].errorText = 'No puede ingresar una fecha posterior a la fecha actual. Por favor intente con otra.';
            return false;
          }
          const { detailData } = this;
          if (detailData) {
            if (detailData.documents) {
              if (dateEmit !== '') {
                if (detailData.documents[index].description === 'Hoja de vida' && (<number><unknown>currentDate - <number><unknown>dateEmit) / (1000 * 3600 * 24) >= 30) {
                  this.updatingDocument[index].errorKey = 'dateEmit';
                  this.updatingDocument[index].errorText = 'La fecha de emision debe ser menor a 30 dias';
                  return false;
                }
              }
            }
          }
        }
        else {
          const dateUntil = <Date>documentForm.dateUntil;
          const dateFrom = <Date>documentForm.dateFrom;
          if (documentForm.dateUntil && documentForm.dateFrom) {
            if (dateFrom > currentDate) {
              this.updatingDocument[index].errorKey = 'dateFrom';
              this.updatingDocument[index].errorText = 'No puede ingresar una fecha posterior a la fecha actual. Por favor intente con otra.';
              return false;
            }
            if (dateFrom > dateUntil) {
              this.updatingDocument[index].errorKey = 'dateUntil';
              this.updatingDocument[index].errorText = 'Debe ingresar una fecha posterior a la fecha de inicio de la delegación. Por favor intenta con otra.';
              return false;
            }
          }
          if (!('fileUrl' in documentForm)) {
            this.updatingDocument[index].errorKey = 'fileUrl';
            this.updatingDocument[index].errorText = 'Debe adjuntar un archivo.';
            return false;
          }
        }
      }
      this.updatingDocument[index].errorKey = '';
      this.updatingDocument[index].errorText = '';
      return true;
    });
    this.formOk = allOk && documentWasModified;
    return allOk;
  }

  onCalendarSetDate(index: number, type: 'dateEmit' | 'dateFrom' | 'dateUntil', date: Date | undefined) {
    if (!this.updatingDocument[index]) this.updatingDocument[index] = {};
    this.updatingDocument[index][type] = date;
    this.verifyEditForm();
  }

  /// ////////////// validacion de  actualizacion  /////////////
  agreeTerms = new FormControl(false)

  showModalConfirmTermsAndConditions() {
    this.assetsFilesService.getTermsAndConditions().subscribe({
      next: (text) => {
        const parsedText = text.replace(/(?:\r\n|\r|\n)/g, '\\n');

        this.store.dispatch(
          modalShow({
            title: 'Términos y condiciones',
            text: parsedText,
            acceptButtonText: 'Aceptar',
            actionOnAccept: () => { },
          }),
        );
      },
    });
  }

  getTextOfEntity(text?: string): string {
    if (!text) {
      return '';
    }
    if (!(text.includes('Empleados:') || text.includes('Contratistas:'))) {
      return text;
    }
    const searchKey = this.driverIsEmployee ? 'Empleados:' : 'Contratistas:';

    if (!text.includes(searchKey)) {
      return '';
    }
    const textList = text.split('\\n');

    return textList.find((x) => x.includes(searchKey))!.replace(searchKey, '').trim();
  }

}
